export default __webpack_public_path__ + "static/media/dear_god.785dc0fc.mp3";